import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore/lite";

const firebaseConfig = {
  apiKey: "AIzaSyA-a_f0ZVXxE_nzm6UAz_up-8RwtqiyNhM",
  authDomain: "bcc-ctg-admission.firebaseapp.com",
  projectId: "bcc-ctg-admission",
  storageBucket: "bcc-ctg-admission.appspot.com",
  messagingSenderId: "257460142665",
  appId: "1:257460142665:web:b0ca40ddb94a55d2033598"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

export { db, app };
